import { resolveAccountKind, ACCOUNT_ROLE_META } from "@/lib/accountRole";

// Colored role label. The TEXT is the label (not color alone), so it passes on its own.
// Pass either an `account` object (role/is_dealer/is_dealer_applicant/account_kind) or an explicit `kind`.
export function RoleTag({ account, kind, className = "" }) {
  const k = kind || resolveAccountKind(account || {});
  const meta = ACCOUNT_ROLE_META[k] || ACCOUNT_ROLE_META.user;
  return (
    <span
      data-testid={`role-tag-${meta.testid}`}
      title={meta.label}
      className={`inline-block font-mono text-[10px] ${meta.bold ? "font-bold" : "font-semibold"} uppercase tracking-wider whitespace-nowrap ${className}`}
      style={{ color: meta.color }}
    >
      {meta.label}
    </span>
  );
}
